import { Dispatch } from "redux";
import { StoreAction } from "../../utils/actions";
import { IRegistrationDropdownData } from "../../app/PublicPages/core/models";

/** Set full event list */
export const fetchRegistrationDropdownDataAction =
    (eventData: IRegistrationDropdownData | null) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.FETCH_REGISTRATION_DROPDOWN_DATA,
                payload: eventData,
            });
        };

export const clearReduxAction = () => (dispatch: Dispatch) => {
    dispatch({
        type: StoreAction.CLEAR_REDUX,
    });
};